import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import { PERIODOS_HORARIOS } from "../../../../shared/constants";
import { fmtDateFull, todayISO } from "../../../../shared/utils";
function AdminSalas(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let salas = props.salas;
  let setSalas = props.setSalas;
  let agendamentos = props.agendamentos;
  let showFlash = props.showFlash;
  const [form, setForm] = useState({
    nome: "",
    capacidade: 8,
  });
  const [editId, setEditId] = useState(null);
  useEffect(() => {
    if (editId) {
      const sala = salas.find((salaId) => salaId.id === editId);
      if (sala) {
        setForm({
          nome: sala.nome,
          capacidade: sala.capacidade,
        });
      }
    } else
      setForm({
        nome: "",
        capacidade: 8,
      });
  }, [editId, salas]);
  return (
    <div className={"ga"}>
      <div>
        <div
          style={{
            fontWeight: 700,
            color: "rgba(255,255,255,.8)",
            fontSize: 13,
            marginBottom: 10,
          }}
        >
          {salas.length}
          {" sala(s) cadastrada(s)"}
        </div>
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: 0,
              background: "#FFF",
              borderRadius: 11,
              overflow: "hidden",
              boxShadow: "0 2px 8px rgba(0,0,0,.07)",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#F4F8F9",
                }}
              >
                {["Nome", "Capacidade", "Data de Criação", "Ações"].map(
                  (item) => (
                    <th
                      style={{
                        padding: "10px 12px",
                        textAlign: "left",
                        fontSize: 10,
                        fontWeight: 700,
                        color: "#6B8590",
                        textTransform: "uppercase",
                        letterSpacing: ".05em",
                        borderBottom: "1px solid #F0F4F6",
                      }}
                      key={item}
                    >
                      {item}
                    </th>
                  ),
                )}
              </tr>
            </thead>
            <tbody>
              {salas.map((sala) => (
                <tr key={sala.id}>
                  <td
                    style={{
                      padding: "10px 12px",
                      borderBottom: "1px solid #F0F4F6",
                      fontSize: 13,
                      fontWeight: 600,
                      color: "#1F4754",
                    }}
                  >
                    {sala.nome}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      borderBottom: "1px solid #F0F4F6",
                      fontSize: 13,
                      color: "#6B8590",
                    }}
                  >
                    {sala.capacidade}
                    {" pessoas"}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      borderBottom: "1px solid #F0F4F6",
                      fontSize: 12,
                      color: "#6B8590",
                    }}
                  >
                    {sala.criado_em
                      ? new Date(sala.criado_em).toLocaleDateString("pt-BR") +
                        " " +
                        new Date(sala.criado_em).toLocaleTimeString("pt-BR", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "-"}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      borderBottom: "1px solid #F0F4F6",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: 5,
                      }}
                    >
                      <button
                        className={"btn bg bs"}
                        style={{
                          fontSize: 11,
                          padding: "5px 10px",
                        }}
                        onClick={() => setEditId(sala.id)}
                      >
                        {"Alterar"}
                      </button>
                      <button
                        className={"btn bd bs"}
                        style={{
                          fontSize: 11,
                          padding: "5px 10px",
                        }}
                        onClick={() =>
                          (async (resultado) => {
                            if (
                              agendamentos.some(
                                (agendamento) =>
                                  agendamento.sala_id === resultado &&
                                  "confirmado" === agendamento.status &&
                                  agendamento.data >= todayISO(),
                              )
                            )
                              showFlash(
                                "Sala tem agendamentos ativos. Cancele-os antes.",
                                "er",
                              );
                            else
                              try {
                                await institutionApi.delete(
                                  "/salas?id=".concat(resultado),
                                );
                                setSalas(
                                  salas.filter(
                                    (salaId) => salaId.id !== resultado,
                                  ),
                                );
                                showFlash("Sala desativada.", "in");
                              } catch (err) {
                                showFlash(
                                  err.response?.data?.message ||
                                    "Nao foi possivel excluir a sala.",
                                  "er",
                                );
                              }
                          })(sala.id)
                        }
                      >
                        {institutionContext ? "Desativar" : "Excluir"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <form
        className={"fc"}
        onSubmit={async (event) => {
          event.preventDefault();
          if (!form.nome.trim()) {
            showFlash("Nome obrigatório.", "er");
            return;
          }
          const salaAtual = salas.find((sala) => sala.id === editId);
          const dados = {
            nome: form.nome.trim(),
            capacidade: Number(form.capacidade),
            criado_em: salaAtual?.criado_em || Date.now(),
          };
          try {
            const responseData2 = editId
              ? await institutionApi.put("/salas?id=".concat(editId), dados)
              : await institutionApi.post("/salas", dados);
            const saved = responseData2.data?.data ?? responseData2.data;
            if (editId) {
              setSalas(
                salas.map((sala) => (sala.id === editId ? saved : sala)),
              );
              showFlash("Sala atualizada!");
              setEditId(null);
            } else {
              setSalas([...salas, saved]);
              showFlash("Sala criada!");
              setForm({
                nome: "",
                capacidade: 8,
              });
            }
          } catch (err) {
            showFlash(
              err.response?.data?.message || "Nao foi possivel salvar a sala.",
              "er",
            );
          }
        }}
      >
        <div
          style={{
            fontWeight: 800,
            color: "#1F4754",
            fontSize: 15,
            marginBottom: 12,
          }}
        >
          {editId ? "Editar Sala" : "Criar Nova Sala"}
        </div>
        <div className={"fg"}>
          <label>{"Nome da Sala *"}</label>
          <input
            className={"inp"}
            value={form.nome}
            onChange={(event) =>
              setForm({
                ...form,
                nome: event.target.value,
              })
            }
            required={true}
            placeholder={"Ex: Sala 101"}
          />
        </div>
        <div className={"fg"}>
          <label>{"Capacidade (alunos) *"}</label>
          <input
            type={"number"}
            min={"1"}
            max={"50"}
            className={"inp"}
            value={form.capacidade}
            onChange={(event) =>
              setForm({
                ...form,
                capacidade: event.target.value,
              })
            }
            required={true}
            placeholder={"Ex: 30"}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
          }}
        >
          <button type={"submit"} className={"btn"}>
            {editId ? "Salvar" : "Criar Sala"}
          </button>
          {editId && (
            <button
              type={"button"}
              className={"btn bg"}
              onClick={() => setEditId(null)}
            >
              {"Cancelar"}
            </button>
          )}
        </div>
      </form>
    </div>
  );
} // ============================================================
// ADMIN — BLOQUEIOS
// ============================================================

// ============================================================
// ADMIN — BLOQUEIOS
// ============================================================
// ============================================================
// ADMIN — BLOQUEIOS
// ============================================================

function AdminBloqueios(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let salas = props.salas;
  let bloqueios = props.bloqueios;
  let setBloqueios = props.setBloqueios;
  let agendamentos = props.agendamentos;
  let setAgendamentos = props.setAgendamentos;
  let showFlash = props.showFlash;
  const [tipo, setTipo] = useState("unico");
  const [form, setForm] = useState({
    data_especifica: "",
    dia_semana: "0",
    periodo: "",
    sala_id: "",
    motivo: "",
  });
  const DIAS = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ];
  const periodoLabel = (periodo) => {
    return (
      PERIODOS_HORARIOS.find((periodoAtual2) => periodoAtual2.id === periodo)
        ?.label || "Todos os períodos"
    );
  };
  return (
    <div className={"ga"}>
      <div>
        <div
          style={{
            fontWeight: 700,
            color: "rgba(255,255,255,.8)",
            fontSize: 13,
            marginBottom: 10,
          }}
        >
          {"Bloqueios ativos: "}
          {bloqueios.length}
        </div>
        {0 === bloqueios.length ? (
          <div className={"es"}>
            <h3>{"Nenhum bloqueio"}</h3>
            <p>{"Crie bloqueios para datas ou dias da semana."}</p>
          </div>
        ) : (
          bloqueios.map((bloqueio) => {
            const sala = salas.find((salaId) => salaId.id === bloqueio.sala_id);
            return (
              <div
                style={{
                  background: "rgba(255,255,255,.07)",
                  borderRadius: 10,
                  padding: "10px 13px",
                  marginBottom: 7,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: 10,
                }}
                key={bloqueio.id}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      gap: 7,
                      alignItems: "center",
                      marginBottom: 4,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: 800,
                        padding: "2px 8px",
                        borderRadius: 999,
                        background:
                          "unico" === bloqueio.tipo ? "#FFF3CD" : "#E0E8F9",
                        color:
                          "unico" === bloqueio.tipo ? "#856404" : "#2A5868",
                      }}
                    >
                      {"unico" === bloqueio.tipo ? "Unico" : "Recorrente"}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "rgba(255,255,255,.9)",
                    }}
                  >
                    {"unico" === bloqueio.tipo
                      ? fmtDateFull(bloqueio.data_especifica)
                      : "Todas as ".concat(DIAS[bloqueio.dia_semana || 0], "s")}
                    {bloqueio.periodo
                      ? " — ".concat(periodoLabel(bloqueio.periodo))
                      : " — Todos os períodos"}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "rgba(255,255,255,.5)",
                      marginTop: 2,
                    }}
                  >
                    {sala ? sala.nome : "Todas as salas"}
                    {bloqueio.motivo ? " · ".concat(bloqueio.motivo) : ""}
                  </div>
                </div>
                <button
                  className={"btn bd bs"}
                  style={{
                    fontSize: 11,
                    padding: "5px 10px",
                    flexShrink: 0,
                  }}
                  onClick={() =>
                    (async (resultado) => {
                      try {
                        await institutionApi.delete(
                          "/bloqueios?id=".concat(resultado),
                        );
                        setBloqueios(
                          bloqueios.filter(
                            (bloqueioId) => bloqueioId.id !== resultado,
                          ),
                        );
                        showFlash("Bloqueio desativado.", "in");
                      } catch (err) {
                        showFlash(
                          err.response?.data?.message ||
                            "Nao foi possivel remover o bloqueio.",
                          "er",
                        );
                      }
                    })(bloqueio.id)
                  }
                >
                  {institutionContext ? "Desativar" : "Remover"}
                </button>
              </div>
            );
          })
        )}
      </div>
      <form
        className={"fc"}
        onSubmit={async (event) => {
          event.preventDefault();
          if ("unico" === tipo && !form.data_especifica) {
            showFlash("Informe a data.", "er");
            return;
          }
          if (!form.periodo) {
            showFlash("Informe o período.", "er");
            return;
          }
          const novo = {
            tipo,
            sala_id: form.sala_id ? Number(form.sala_id) : null,
            data_especifica: "unico" === tipo ? form.data_especifica : null,
            dia_semana: "recorrente" === tipo ? Number(form.dia_semana) : null,
            periodo: form.periodo || null,
            motivo: form.motivo.trim(),
          };
          try {
            const responseData3 = await institutionApi.post("/bloqueios", novo);
            const created = responseData3.data?.data ?? responseData3.data;
            setBloqueios((prev) => [...prev, created]);
            if ("unico" === tipo && form.data_especifica) {
              const afetados = agendamentos.filter((agendamento) => {
                if ("confirmado" !== agendamento.status) return false;
                const salaCond =
                  !novo.sala_id || novo.sala_id === agendamento.sala_id;
                const perCond =
                  !novo.periodo || novo.periodo === agendamento.periodo;
                return (
                  salaCond &&
                  perCond &&
                  agendamento.data === novo.data_especifica
                );
              });
              if (afetados.length > 0) {
                let updates = [];
                try {
                  const updatesRaw =
                    (
                      await institutionApi.put("/agendamentos/lote", {
                        items: afetados.map((afetado) => ({
                          ...afetado,
                          status: "cancelado",
                        })),
                      })
                    ).data?.data ?? [];
                  updates = Array.isArray(updatesRaw)
                    ? updatesRaw
                    : [updatesRaw];
                } catch (err) {
                  if (![404, 405].includes(err.response?.status)) throw err;
                  updates = await Promise.all(
                    afetados.map(async (afetado) => {
                      const res = await institutionApi.put(
                        "/agendamentos?id=".concat(afetado.id),
                        {
                          ...afetado,
                          status: "cancelado",
                        },
                      );
                      return res.data?.data ?? res.data;
                    }),
                  );
                }
                const byId = new Map(
                  updates.map((update) => [update.id, update]),
                );
                setAgendamentos((prev) =>
                  prev.map((prevId) => byId.get(prevId.id) || prevId),
                );
                showFlash(
                  "Bloqueio criado! ".concat(
                    updates.length,
                    " agendamento(s) cancelado(s).",
                  ),
                  "wa",
                );
              } else showFlash("Bloqueio criado!");
            } else showFlash("Bloqueio criado!");
            setForm({
              data_especifica: "",
              dia_semana: "0",
              periodo: "",
              sala_id: "",
              motivo: "",
            });
          } catch (err) {
            showFlash(
              err.response?.data?.message ||
                "Nao foi possivel criar o bloqueio.",
              "er",
            );
          }
        }}
      >
        <div
          style={{
            fontWeight: 800,
            color: "#1F4754",
            fontSize: 15,
            marginBottom: 12,
          }}
        >
          {"Criar Bloqueio"}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 8,
            marginBottom: 14,
          }}
        >
          {[
            [
              "unico",
              "[1]",
              "Bloqueio Unico",
              "Bloqueia apenas uma data específica",
              "Ex: 25/12/2025",
            ],
            [
              "recorrente",
              "[R]",
              "Bloqueio Recorrente",
              "Bloqueia todas as ocorrências de um dia da semana",
              "Ex: Todas as terças-feiras",
            ],
          ].map((item) => {
            const [
              resultado,
              setValue,
              resultadoAtual2,
              resultadoAtual3,
              resultadoAtual4,
            ] = item;
            return (
              <div
                onClick={() => setTipo(resultado)}
                style={{
                  border: "2px solid ".concat(
                    tipo === resultado ? "#1F4754" : "#E0E8EB",
                  ),
                  borderRadius: 12,
                  padding: "12px 10px",
                  cursor: "pointer",
                  background: tipo === resultado ? "#EAF4F7" : "#FFF",
                  textAlign: "center",
                }}
                key={resultado}
              >
                <div
                  style={{
                    fontSize: 24,
                    marginBottom: 5,
                  }}
                >
                  {setValue}
                </div>
                <div
                  style={{
                    fontWeight: 800,
                    color: "#1F4754",
                    fontSize: 13,
                    marginBottom: 4,
                  }}
                >
                  {resultadoAtual2}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#6B8590",
                    marginBottom: 3,
                  }}
                >
                  {resultadoAtual3}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#B8C5CC",
                  }}
                >
                  {resultadoAtual4}
                </div>
              </div>
            );
          })}
        </div>
        {"unico" === tipo ? (
          <div className={"fg"}>
            <label>{"Data Específica *"}</label>
            <input
              type={"date"}
              className={"inp"}
              value={form.data_especifica}
              min={todayISO()}
              onChange={(event) =>
                setForm({
                  ...form,
                  data_especifica: event.target.value,
                })
              }
              required={true}
            />
          </div>
        ) : (
          <div className={"fg"}>
            <label>{"Dia da Semana *"}</label>
            <select
              className={"sel"}
              value={form.dia_semana}
              onChange={(event) =>
                setForm({
                  ...form,
                  dia_semana: event.target.value,
                })
              }
            >
              {DIAS.map((DIASItem, index) => (
                <option value={index} key={index}>
                  {DIASItem}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className={"fg"}>
          <label>{"Período *"}</label>
          <select
            className={"sel"}
            value={form.periodo}
            onChange={(event) =>
              setForm({
                ...form,
                periodo: event.target.value,
              })
            }
            required={true}
          >
            <option value={""}>{"-- Selecione --"}</option>
            {PERIODOS_HORARIOS.map((periodo) => (
              <option value={periodo.id} key={periodo.id}>
                {periodo.label}
              </option>
            ))}
          </select>
        </div>
        <div className={"fg"}>
          <label>{"Sala (opcional)"}</label>
          <select
            className={"sel"}
            value={form.sala_id}
            onChange={(event) =>
              setForm({
                ...form,
                sala_id: event.target.value,
              })
            }
          >
            <option value={""}>{"-- Todas as salas --"}</option>
            {salas.map((sala) => (
              <option value={sala.id} key={sala.id}>
                {sala.nome}
              </option>
            ))}
          </select>
          <div
            style={{
              fontSize: 11,
              color: "#6B8590",
              marginTop: 3,
            }}
          >
            {"Deixe em branco para bloquear todas as salas"}
          </div>
        </div>
        <div className={"fg"}>
          <label>{"Motivo"}</label>
          <input
            className={"inp"}
            value={form.motivo}
            onChange={(event) =>
              setForm({
                ...form,
                motivo: event.target.value,
              })
            }
            placeholder={"Ex: Feriado, Manutenção, Recesso, etc."}
          />
        </div>
        <button
          type={"submit"}
          className={"btn"}
          style={{
            background: "#D9534F",
          }}
        >
          {"Criar Bloqueio"}
        </button>
      </form>
    </div>
  );
}

// ============================================================
// ADMIN — AGENDAMENTOS
// ============================================================

// ============================================================
// ADMIN — AGENDAMENTOS
// ============================================================
export default function AdminAgendamentos(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  const agendamentos = props.agendamentos;
  const setAgendamentos = props.setAgendamentos;
  const salas = props.salas;
  const setSalas = props.setSalas;
  const bloqueios = props.bloqueios;
  const setBloqueios = props.setBloqueios;
  const students = props.students;
  const showFlash = props.showFlash;
  const [aba, setAba] = useState("agendamentos");
  return (
    <div>
      <div
        className={"tabs"}
        style={{
          marginBottom: 14,
        }}
      >
        <button
          className={"agendamentos" === aba ? "a" : ""}
          onClick={() => setAba("agendamentos")}
        >
          {"Agendamentos"}
        </button>
        <button
          className={"salas" === aba ? "a" : ""}
          onClick={() => setAba("salas")}
        >
          {"Salas"}
        </button>
        <button
          className={"bloqueios" === aba ? "a" : ""}
          onClick={() => setAba("bloqueios")}
        >
          {"Bloqueios"}
        </button>
      </div>
      {"agendamentos" === aba && (
        <AdminAgendamentosLista
          agendamentos={agendamentos}
          setAgendamentos={setAgendamentos}
          salas={salas}
          students={students}
          showFlash={showFlash}
          institutionContext={institutionContext}
        />
      )}
      {"salas" === aba && (
        <AdminSalas
          salas={salas}
          setSalas={setSalas}
          agendamentos={agendamentos}
          showFlash={showFlash}
          institutionContext={institutionContext}
        />
      )}
      {"bloqueios" === aba && (
        <AdminBloqueios
          salas={salas}
          bloqueios={bloqueios}
          setBloqueios={setBloqueios}
          agendamentos={agendamentos}
          setAgendamentos={setAgendamentos}
          showFlash={showFlash}
          institutionContext={institutionContext}
        />
      )}
    </div>
  );
}
function AdminAgendamentosLista(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let agendamentos = props.agendamentos;
  let setAgendamentos = props.setAgendamentos;
  let salas = props.salas;
  let students = props.students;
  let showFlash = props.showFlash;
  const [data, setData] = useState(todayISO());
  const [periodo, setPeriodo] = useState("");
  const [expandido, setExpandido] = useState(null);
  const filtrados = agendamentos.filter(
    (agendamento) =>
      agendamento.data === data &&
      (!periodo || agendamento.periodo === periodo),
  );
  const porSala = salas.map((sala) => ({
    sala,
    ags: filtrados.filter((filtrado) => filtrado.sala_id === sala.id),
  }));
  const periodoLabel = (periodoAtual2) => {
    return (
      PERIODOS_HORARIOS.find(
        (periodoAtual3) => periodoAtual3.id === periodoAtual2,
      )?.label || periodoAtual2
    );
  };
  const STATUS_OPTS = ["confirmado", "pendente", "cancelado", "faltou"];
  useEffect(() => {
    institutionContext?.onDay?.(data);
  }, [data, institutionContext?.onDay]);
  return (
    <div>
      <div
        className={"fc"}
        style={{
          marginBottom: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <div
            className={"fg"}
            style={{
              flex: 1,
              margin: 0,
            }}
          >
            <label>{"Data"}</label>
            <input
              type={"date"}
              className={"inp"}
              value={data}
              onChange={(event) => setData(event.target.value)}
            />
          </div>
          <div
            className={"fg"}
            style={{
              flex: 1,
              margin: 0,
            }}
          >
            <label>{"Período"}</label>
            <select
              className={"sel"}
              value={periodo}
              onChange={(event) => setPeriodo(event.target.value)}
            >
              <option value={""}>{"Todos"}</option>
              {PERIODOS_HORARIOS.map((periodoAtual2) => (
                <option value={periodoAtual2.id} key={periodoAtual2.id}>
                  {periodoAtual2.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3,1fr)",
          gap: 8,
          marginBottom: 14,
        }}
      >
        {[
          ["Total", filtrados.length, "#4FB3A9"],
          [
            "Confirmados",
            filtrados.filter((filtrado) => "confirmado" === filtrado.status)
              .length,
            "#1A7A6E",
          ],
          [
            "Cancelados",
            filtrados.filter((filtrado) => "cancelado" === filtrado.status)
              .length,
            "#D9534F",
          ],
        ].map((item) => {
          const [resultado, setValue, resultadoAtual2] = item;
          return (
            <div
              style={{
                background: "#FFF",
                borderRadius: 11,
                padding: "11px 12px",
                boxShadow: "0 2px 6px rgba(0,0,0,.07)",
                borderTop: "3px solid ".concat(resultadoAtual2),
              }}
              key={resultado}
            >
              <div
                style={{
                  fontSize: 10,
                  color: "#6B8590",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: ".05em",
                }}
              >
                {resultado}
              </div>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: resultadoAtual2,
                  marginTop: 3,
                }}
              >
                {setValue}
              </div>
            </div>
          );
        })}
      </div>
      {porSala.map((porSalaSala) => {
        let sala = porSalaSala.sala;
        let ags = porSalaSala.ags;
        return (
          <div
            style={{
              background: "rgba(255,255,255,.07)",
              borderRadius: 12,
              overflow: "hidden",
              marginBottom: 10,
            }}
            key={sala.id}
          >
            <div
              style={{
                background: "rgba(255,255,255,.1)",
                padding: "10px 14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() =>
                setExpandido(expandido === sala.id ? null : sala.id)
              }
            >
              <div
                style={{
                  fontWeight: 800,
                  color: "#FFF",
                  fontSize: 13,
                }}
              >
                {sala.nome}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: 12,
                    color: "rgba(255,255,255,.6)",
                  }}
                >
                  {ags.filter((item) => "confirmado" === item.status).length}
                  {"/"}
                  {sala.capacidade}
                  {" confirmados"}
                </span>
                <span
                  style={{
                    color: "rgba(255,255,255,.5)",
                    fontSize: 14,
                  }}
                >
                  {expandido === sala.id ? "▲" : "▼"}
                </span>
              </div>
            </div>
            {expandido === sala.id && (
              <div
                style={{
                  padding: "10px 14px",
                }}
              >
                <div
                  style={{
                    fontWeight: 700,
                    color: "rgba(255,255,255,.7)",
                    fontSize: 12,
                    marginBottom: 8,
                  }}
                >
                  {"Alunos agendados:"}
                </div>
                {0 === ags.length ? (
                  <div
                    style={{
                      color: "rgba(255,255,255,.4)",
                      fontSize: 12,
                      padding: "8px 0",
                    }}
                  >
                    {"Nenhum agendamento"}
                  </div>
                ) : (
                  ags.map((item) => {
                    const student = students.find(
                      (studentId) => studentId.id === item.aluno_id,
                    );
                    return (
                      <div
                        style={{
                          background: "rgba(255,255,255,.05)",
                          borderRadius: 9,
                          padding: "10px 12px",
                          marginBottom: 7,
                        }}
                        key={item.id}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            marginBottom: item.convidado ? 6 : 0,
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: "rgba(255,255,255,.9)",
                              }}
                            >
                              {student?.nome || "Desconhecido"}
                            </div>
                            {item.convidado && (
                              <div
                                style={{
                                  fontSize: 11,
                                  color: "#A78BFA",
                                  marginTop: 2,
                                }}
                              >
                                {"Convidado: "}
                                {item.convidado}
                              </div>
                            )}
                          </div>
                          <select
                            value={item.status}
                            onChange={(event) =>
                              (async (resultado, status) => {
                                const atual = agendamentos.find(
                                  (agendamento) => agendamento.id === resultado,
                                );
                                if (atual)
                                  try {
                                    const responseData2 =
                                      await institutionApi.put(
                                        "/agendamentos?id=".concat(resultado),
                                        {
                                          ...atual,
                                          status,
                                        },
                                      );
                                    const saved =
                                      responseData2.data?.data ??
                                      responseData2.data;
                                    setAgendamentos(
                                      agendamentos.map((agendamento) =>
                                        agendamento.id === resultado
                                          ? saved
                                          : agendamento,
                                      ),
                                    );
                                    showFlash(
                                      "confirmado" === status
                                        ? "Confirmado!"
                                        : "Status atualizado.",
                                      "ok",
                                    );
                                  } catch (err) {
                                    showFlash(
                                      err.response?.data?.message ||
                                        "Nao foi possivel atualizar o status.",
                                      "er",
                                    );
                                  }
                              })(item.id, event.target.value)
                            }
                            style={{
                              background: "rgba(255,255,255,.15)",
                              border: "none",
                              color: "#FFF",
                              borderRadius: 8,
                              padding: "6px 10px",
                              fontSize: 12,
                              fontFamily: "inherit",
                              cursor: "pointer",
                            }}
                          >
                            {STATUS_OPTS.map((STATUS_OPTSCharAt) => (
                              <option
                                value={STATUS_OPTSCharAt}
                                style={{
                                  color: "#1F4754",
                                }}
                                key={STATUS_OPTSCharAt}
                              >
                                {STATUS_OPTSCharAt.charAt(0).toUpperCase() +
                                  STATUS_OPTSCharAt.slice(1)}
                              </option>
                            ))}
                          </select>
                        </div>
                        {item.periodo && (
                          <div
                            style={{
                              fontSize: 11,
                              color: "rgba(255,255,255,.4)",
                              marginTop: 3,
                            }}
                          >
                            {periodoLabel(item.periodo)}
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ============================================================

// ============================================================

// ============================================================
export { AdminAgendamentos };
